import axios from "axios";
import {
  urlAlteracoes,
  urlHabilidades, urlHistoricoAlteracoes,
  urlModulos, urlRegistroLogs,
  urlRelatoriosExcelImport, urlRequestErrors,
  urlRoles, urlSistemas
} from '../../../../constants/endpoints';

// abilities
export const listaHabilidades = (filter = null) => axios.get(urlHabilidades, { params: filter });
export const cadastraHabilidade = (data) => axios.post(`${urlHabilidades}`, data);
export const atualizaHabilidade = (id, data) => axios.patch(`${urlHabilidades}/${id}`, data);
export const manipulaHabilidade = (data, isEditAction) => isEditAction ? atualizaHabilidade(data.id, data) : cadastraHabilidade(data);
export const deletaHabilidade = (id) => axios.delete(`${urlHabilidades}/${id}`);

// modulos
export const listaModulos = (filter = null) => axios.get(urlModulos, { params: filter });
export const cadastraModulo = (data) => axios.post(`${urlModulos}`, data);
export const atualizaModulo = (id, data) => axios.patch(`${urlModulos}/${id}`, data);
export const manipulaModulo = (data, isEditAction) => isEditAction ? atualizaModulo(data.id, data) : cadastraModulo(data);
export const deletaModulo = (id) => axios.delete(`${urlModulos}/${id}`);

// roles
export const listaRoles = (filter = null) => axios.get(urlRoles, { params: filter });
export const deletaRole = (id) => axios.delete(`${urlRoles}/${id}`);

// planilhas de importação
export const RelatoriosExcelImport = (formData) => axios.post(urlRelatoriosExcelImport, formData, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

// logs
export const listLogs = (filter = null) => axios.get(urlRegistroLogs, { params: filter });

// errors
export const listRequestErrors = (filter = null) => axios.get(urlRequestErrors, { params: filter });
export const getRequestErrorsData = (idErroRequest) => axios.get(`${urlRequestErrors}/${idErroRequest}`);

export const listaSistemas = (filter = null) => axios.get(`${urlSistemas}`, { params: filter });
export const cadastraSistema = (data) => axios.post(`${urlSistemas}`, data);
export const atualizaSistema = (id, data) => axios.patch(`${urlSistemas}/${id}`, data);
export const manipulaSistema = (data, isEditAction) => isEditAction ? atualizaSistema(data.id, data) : cadastraSistema(data);
export const deletaSistema = (id) => axios.delete(`${urlSistemas}/${id}`);

export const listaChangelogs = (filter = null) => axios.get(`${urlAlteracoes}`, { params: filter });
export const cadastraChangelog = (data) => {
  return axios.post(`${urlAlteracoes}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const atualizaChangelog = (id, data) => {
  return axios.post(`${urlAlteracoes}/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
export const manipulaChangelog = (data, isEditAction) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };

  if (isEditAction) {
    const id = Number(data.get ? data.get('id') : data.id);
    return atualizaChangelog(id, data, config);
  }

  return cadastraChangelog(data, config);
};
export const deletaChangelog = (id) => axios.delete(`${urlAlteracoes}/${id}`);
export const downloadChangelog = (id) => axios.get(`${urlAlteracoes}/download/${id}`);

export const verificaChangelogs = (filter = null) => axios.get(`${urlHistoricoAlteracoes}`, { params: filter });
export const enviaChangelog = (data) => axios.post(`${urlHistoricoAlteracoes}`, data);
export const atualizaChangelogNotificacao = (id, data) => axios.patch(`${urlHistoricoAlteracoes}/${id}`, data);
